export function useLocalisedDate() {
  const { locale } = useI18n()
  const intlLocale = computed(() => getIntlLocale(locale.value))
  const dateLocale = computed(() => intlLocale.value.replace("en-US", "en-GB"))

  const dateFormatOptions: Intl.DateTimeFormatOptions = {
    dateStyle: "short",
  }
  const dateTimeFormatOptions: Intl.DateTimeFormatOptions = {
    dateStyle: "short",
    timeStyle: "short",
  }

  /**
   * Returns a string with only the date in user's locale
   */
  function getDate(input: string | Date | number): string {
    const date = input instanceof Date ? input : new Date(input)

    const day = date.getDate().toString().padStart(2, "0")
    // Months are zero-based, so add 1
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const year = date.getFullYear()

    return `${day}-${month}-${year}`
  }

  /**
   * Returns a string with date and time in user's locale and timezone
   */
  function getDateWithTime(input: string | Date | number): string {
    const date = input instanceof Date ? input : new Date(input)

    const hours = date.getHours().toString().padStart(2, "0")
    const minutes = date.getMinutes().toString().padStart(2, "0")

    return `${getDate(date)} ${hours}:${minutes}`
  }

  /**
   * Returns a date formatted with the provided options in the user's locale.
   */
  function getDateWithOptions(
    input: string | Date | number,
    options: Intl.DateTimeFormatOptions,
  ): string {
    const date = input instanceof Date ? input : new Date(input)

    return new Intl.DateTimeFormat(dateLocale.value, options).format(date)
  }

  /**
   * Returns only the time in user's locale with the local timezone.
   */
  function getTime(input: string | Date | number): string {
    const date = input instanceof Date ? input : new Date(input)

    return new Intl.DateTimeFormat(intlLocale.value, {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    }).format(date)
  }

  return {
    getDate,
    getDateWithOptions,
    getDateWithTime,
    getTime,
    dateFormatOptions,
    dateTimeFormatOptions,
  }
}
